const pageTitlePrefix = ' - Pluva Market';

interface IPageInfo {
  title: string;
  path: string;
}

interface IPluvaMarketPageInfo {
  [key: string]: IPageInfo;
}

export const pageInfo: IPluvaMarketPageInfo = {
  homePage: { title: `홈${pageTitlePrefix}`, path: '/home' },
  infoListPage: { title: `정보${pageTitlePrefix}`, path: '/info/list' },
  infoDetailPage: { title: `정보${pageTitlePrefix}`, path: '/info' },
  subsidyListPage: { title: `지원금${pageTitlePrefix}`, path: '/subsidy/list' },
  subsidyDetailPage: { title: `지원금${pageTitlePrefix}`, path: '/subsidy' },
  productListPage: { title: `매물${pageTitlePrefix}`, path: '/products/list' },
  productDetailPage: { title: `매물${pageTitlePrefix}`, path: '/products' },
  productOptionPage: { title: `매물 옵션${pageTitlePrefix}`, path: '/product-options' },
  openMarketListPage: { title: `오픈마켓${pageTitlePrefix}`, path: '/open-market/list' },
  openMarketDetailPage: { title: `오픈마켓${pageTitlePrefix}`, path: '/open-market' },
  openMarketSearchPage: { title: `직거래 매물 검색${pageTitlePrefix}`, path: '/open-market/search' },
  openMarketSearchResultPage: { title: `직거래 매물 검색 결과${pageTitlePrefix}`, path: '/open-market/search-result' },
  tractorPokingListPage: { title: `찔러보기${pageTitlePrefix}`, path: '/tractor-poking/list' },
  tractorPokingDetailPage: { title: `찔러보기${pageTitlePrefix}`, path: '/tractor-poking' },
  myInfoPage: { title: `마이${pageTitlePrefix}`, path: '/myinfo' },
  myInfoAlarmSettingPage: { title: `알람 설정${pageTitlePrefix}`, path: '/myinfo/alarm-setting' },
  myInfoEditProfilePage: { title: `프로필 수정${pageTitlePrefix}`, path: '/edit-profile' },
  myInfoOwnTractorListPage: { title: `보유 트랙터 관리${pageTitlePrefix}`, path: '/own-tractor-list' },
  myInfoOwnTractorDetailPage: { title: `찔러보기 요청 확인${pageTitlePrefix}`, path: '/own-tractor' },
  myInfoSellTractorListPage: { title: `판매 트랙터 관리${pageTitlePrefix}`, path: '/sell-tractor-list' },
  myInfoPokeListPage: { title: `찔러본 트랙터 관리${pageTitlePrefix}`, path: '/poke-tractor-list' },
  deleteAccountPage: { title: `회원 탈퇴${pageTitlePrefix}`, path: '/delete-account' },
  loginPage: { title: `로그인${pageTitlePrefix}`, path: '/oauth/login' },
  LoginResultPage: { title: `로그인${pageTitlePrefix}`, path: '/oauth/login-result' },
  afterLoginPage: { title: `로그인${pageTitlePrefix}`, path: '/after-login' },
  termsOfUseList: { title: `플루바마켓 이용약관${pageTitlePrefix}`, path: '/terms-of-use/list' },
  downloadAppPage: { title: `플루바마켓 앱 다운로드${pageTitlePrefix}`, path: '/download-app' },
  pluvaAutoPage: { title: '플루바 오토', path: '/pluva-auto' },
  pluvaAutoBusinessPage: { title: '플루바 오토 사용후기', path: '/pva' },
  pluvaAutoCustomerServicePage: { title: '플루바 오토 사용법', path: '/pva-cs' },
  sellTractorEntryPage: { title: `내 트랙터 판매${pageTitlePrefix}`, path: '/survey/entry/sell-tractor' },
  joinCompletePage: { title: `회원가입 완료${pageTitlePrefix}`, path: '/join-complete' },
  cropTrendsListPage: { title: `농산물 시세${pageTitlePrefix}`, path: '/crop-trends/list' },
  cropTrendsDetailPage: { title: `농산물 시세 상세${pageTitlePrefix}`, path: '/crop-trends/detail' },
};

export const marketPricePageInfo = {
  listPage: {
    title: '트랙터 시세 목록',
    path: '/market-price/list',
  },
  entryPage: {
    title: '트랙터 시세 엔트리',
    path: '/market-price/entry',
  },
  detailPage: {
    title: `트랙터 시세 상세${pageTitlePrefix}`,
    path: '/market-price',
  },
  searchPage: {
    title: `트랙터 시세 검색${pageTitlePrefix}`,
    path: '/market-price/search',
  },
  searchResultPage: {
    title: `트랙터 시세 검색 결과${pageTitlePrefix}`,
    path: '/market-price/search-result',
  },
} as const;

export const newProductPageInfo: IPluvaMarketPageInfo = {
  listPage: {
    title: `신품관 목록${pageTitlePrefix}`,
    path: '/new-products/list',
  },
  detailPage: {
    title: `신품관 상세${pageTitlePrefix}`,
    path: '/new-products',
  },
};

export const sellTractorPageInfo: IPluvaMarketPageInfo = {
  overviewPage: {
    title: `내 트랙터 판매 정보${pageTitlePrefix}`,
    path: '/survey/progress/sell-tractor/required-input-overview',
  },
  locationPage: {
    title: `내 트랙터 판매 위치${pageTitlePrefix}`,
    path: '/survey/progress/sell-tractor/location',
  },
  optionPage: {
    title: `내 트랙터 판매 옵션${pageTitlePrefix}`,
    path: '/survey/progress/sell-tractor/option',
  },
  pricePage: {
    title: `내 트랙터 판매 가격${pageTitlePrefix}`,
    path: '/survey/progress/sell-tractor/hope-selling-price',
  },
  requireImagePage: {
    title: `내 트랙터 판매 이미지${pageTitlePrefix}`,
    path: '/survey/progress/sell-tractor/tractor-required-image',
  },
  workingMachinePage: {
    title: `내 트랙터 판매 작업기${pageTitlePrefix}`,
    path: '/survey/progress/sell-tractor/working-machine',
  },
  extraInfo1Page: {
    title: `내 트랙터 판매 추가 정보${pageTitlePrefix}`,
    path: '/survey/progress/sell-tractor/extra-info-1',
  },
  tireConditionPage: {
    title: `내 트랙터 판매 타이어 상태${pageTitlePrefix}`,
    path: '/survey/progress/sell-tractor/tire-condition',
  },
  extraInfo2Page: {
    title: `내 트랙터 판매 추가 정보${pageTitlePrefix}`,
    path: '/survey/progress/sell-tractor/extra-info-2',
  },
};

export const ownTractorPageInfo: IPluvaMarketPageInfo = {
  entryPage: {
    title: `내 트랙터 등록하기${pageTitlePrefix}`,
    path: '/survey/entry/own-tractor',
  },
  overviewPage: {
    title: `내 트랙터 필수 정보 입력${pageTitlePrefix}`,
    path: '/survey/progress/own-tractor/required-input-overview',
  },
  marketPricePage: {
    title: `내 트랙터 시장가 입력${pageTitlePrefix}`,
    path: '/survey/progress/own-tractor/market-price',
  },
  imageUploadPage: {
    title: `내 보유 트랙터 이미지 업로드${pageTitlePrefix}`,
    path: '/survey/progress/own-tractor/image-upload',
  },
  completePage: {
    title: `내 보유 트랙터 등록 완료${pageTitlePrefix}`,
    path: '/survey/complete/own-tractor',
  },
};

export const managedFarmPageInfo: IPluvaMarketPageInfo = {
  entryPage: {
    title: `대행 반장${pageTitlePrefix}`,
    path: '/managed-farm/entry',
  },
  searchFieldPage: {
    title: `필지 검색${pageTitlePrefix}`,
    path: '/managed-farm/search-field',
  },
  fieldMapPage: {
    title: `필지 선택${pageTitlePrefix}`,
    path: '/managed-farm/field-map',
  },
  myTaskPage: {
    title: `내 작업 관리${pageTitlePrefix}`,
    path: '/managed-farm/my-task',
  },
  formFieldOwnerPage: {
    title: `필지 소유자 입력${pageTitlePrefix}`,
    path: '/managed-farm/form/field-owner',
  },
  formTaskTypePage: {
    title: `작업 정보 선택${pageTitlePrefix}`,
    path: '/managed-farm/form/task-type',
  },
  formTaskSchedulePage: {
    title: `작업 일정 선택${pageTitlePrefix}`,
    path: '/managed-farm/form/task-schedule',
  },
  formTaskCheckpointPage: {
    title: `작업 확인 사항${pageTitlePrefix}`,
    path: '/managed-farm/form/task-checkpoint',
  },
  taskDetailPage: {
    title: `작업 상세${pageTitlePrefix}`,
    path: '/managed-farm/task-detail',
  },
};

export const PLUVA_SHOP_URL = 'https://shop.pluva.kr/';
